import React from "react";

const IfComponent = ({ condition, children }) =>
  condition ? <>{children}</> : null;
export default IfComponent;
